var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 0c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm.3 2.14286c.47143 0 .9.38571.9.9 0 .51428-.38571.9-.9.9-.47143 0-.9-.38572-.9-.9 0-.51429.38571-.9.9-.9zm-.47143 8.10004c-.77143 0-1.32857-.72861-1.11428-1.45719l.77142-2.57142c.08572-.3-.12857-.55715-.42857-.55715h-.38571c.21428-.64285.81428-1.07143 1.5-1.07143.77143 0 1.32857.72858 1.11428 1.45715l-.77142 2.57143c-.08572.3.12857.55714.42857.55714h.38571c-.21428.64286-.81428 1.07147-1.5 1.07147z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-icon.8d9519da430565431f3118ea81a5ff8f.svg";